import { api } from './_init'

const isHttpSuccess = (status) => status >= 200 && status < 300

const failedResponse = (error) => ({
  success: false,
  error: error.response?.data?.message ?? error.message,
  status: error.response?.status,
  data: error.response?.data ?? null,
})

export const fetchImageGenerationCredits = async () => {
  try {
    const response = await api.get('/integrations/openai/image_generation_credits')

    if (response.status !== 200) {
      throw new Error()
    }

    return {
      success: true,
      data: response.data,
    }
  } catch (error) {
    return failedResponse(error)
  }
}

export const sendGenerateImagesRequest = async (body) => {
  try {
    const response = await api.post('/integrations/openai/generate_images', {
      ...body,
    })

    if (response.status !== 200) {
      throw new Error()
    }

    return {
      success: true,
      data: response.data,
    }
  } catch (error) {
    return failedResponse(error)
  }
}

export const fetchGeneratedImages = async (eventId, tc, tcRunId) => {
  try { 
    const response = await api.get(`/integrations/openai/generated_images?eid=${eventId}&tc=${tc}&tc_run_id=${tcRunId}`)

    if (response.status !== 200) {
      throw new Error()
    }

    return {
      success: true,
      data: response.data,
    }
  } catch (error) {
    return failedResponse(error)
  }
}

export const postGeneratedImages = async (body) => {
  try {
    const response = await api.post('/integrations/openai/cocreate_images', {
      ...body,
    })

    if (!isHttpSuccess(response.status)) {
      throw new Error()
    }

    return {
      success: true,
      data: response.data,
    }

  } catch (error) {
    return failedResponse(error)
  }
}
